import React from 'react'
import { Row, Divider, Col, Form, Typography, Button } from 'antd'
import Segment from '../../components/Segment'
import API from '../../services/API'
import moment from 'moment'
import { Link } from 'react-router-dom'

const { Paragraph } = Typography
const INIT = {
    name: '',
    last_name: '',
    email: '',
    password: '',
    role_id: null,
    boss_id: null,
    active: true,
    subsidiaries: [],
    work_start_date: '',
}
const UsersShowContainer = ({ match }) => {
    const [loading, setloading] = React.useState(false)
    const [data, setData] = React.useState(INIT)

    const getData = () => {
        setloading(true)
        API.get(`/api/users/${match.params.id}?include=role,subsidiaries,boss`)
            .then(response => {
                setData(response.data)
            })
            .catch(error => {
                console.error('Error en obtener el usuario', error)
            })
            .finally(() => {
                setloading(false)
            })
    }
    React.useEffect(() => {
        getData()
    }, [])

    return (
        <Segment loading={loading}>
            <Divider>Detalle del usuario</Divider>
            <Form style={{ maxWidth: '500px', margin: 'auto' }} className="form-border">
                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong={true}>Nombre:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph>{data.name}</Paragraph>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong={true}>Apellido:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph>{data.last_name}</Paragraph>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong={true}>Correo:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph>{data.email}</Paragraph>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong={true}>Perfil:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph>{data.role_id ? data.role.name : ''}</Paragraph>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong={true}>Jefe directo:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph>{data.boss_id ? data.boss.full_name : '-'}</Paragraph>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong={true}>Sucursales:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph>
                            {data.subsidiaries.length ? data.subsidiaries.map(r => r.name).join(', ') : '-'}
                        </Paragraph>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong={true}>Fecha de ingreso laboral:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph>
                            {data.work_start_date ? moment(data.work_start_date).format('DD/MM/YYYY') : '-'}
                        </Paragraph>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong={true}>Activo:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph>{data.active ? 'Si' : 'No'}</Paragraph>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong={true}>Creación:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        {data.created_at ? moment(data.created_at).format('DD/MM/YYYY hh:mm A') : ''}
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong={true}>Actualización:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        {data.updated_at ? moment(data.updated_at).format('DD/MM/YYYY hh:mm A') : ''}
                    </Col>
                </Row>
            </Form>
            <Row type="flex" justify="center" style={{ marginTop: '50px' }}>
                <Form.Item>
                    <Link to={`/users`} style={{ marginLeft: '5px' }}>
                        <Button icon="arrow-left">
                            Regresar
                        </Button>
                    </Link>
                </Form.Item>
            </Row>
        </Segment>
    )
}

export default UsersShowContainer
